import React from "react"
import { useSelector } from "react-redux"

import RemovableStringValueInput from "@root/components/RemovableStringValueInput"
import { RootState, useAppDispatch } from "@root/store"
import { identifyContact, resetContact } from "@root/store/thunks"

const NamedUser: React.FC = () => {
  const contact = useSelector((state: RootState) => state.contact)
  const dispatch = useAppDispatch()

  const onIdentify = React.useCallback(
    (namedUserId: string) => dispatch(identifyContact(namedUserId)),
    [dispatch]
  )
  const onReset = React.useCallback(() => dispatch(resetContact()), [dispatch])

  return (
    <>
      <RemovableStringValueInput
        id="named-user"
        label="Named User"
        initialValue={contact.name}
        onValueSet={(val) => {
          if (val) {
            onIdentify(val)
          } else {
            onReset()
          }
        }}
      />
    </>
  )
}

export default NamedUser
